import ProductCard from "@/components/ProductCard";

const ProductGrid = ({ items, testId = "product-grid" }) => {
  return (
    <div className="product-grid" data-testid={testId}>
      {items.map((p) => (
        <ProductCard key={p.id} product={p} />
      ))}
    </div>
  );
};

export default ProductGrid;
